export interface SettingsObject {
  entity: string;
  id?: string;
  system: Record<string, unknown>;
  organization: string;
}

interface MemberSettings {
  historyOptions: Record<string, boolean>;
  chartOptions: Record<string, boolean>;
  vitalTileOptions: Record<string, boolean>;
  spirometryVisibility: Record<string, boolean>;
}
interface MemberSettingsObject {
  entity: string;
  id: string;
  system: { settings: MemberSettings };
  organization: string;
}

export interface SettingsPatchObject {
  system?: Record<string, unknown>;
  organization?: string;
}

export interface SettingsContextInterface {
  default: {
    loaded: boolean;
    data: SettingsObject | null;
  };
  coordinator: {
    loaded: boolean;
    data: SettingsObject | null;
  };
  member: {
    memberId: string | null;
    loading: boolean;
    data: MemberSettingsObject | null;
  };
}

export const settingsContext: SettingsContextInterface = {
  default: { loaded: false, data: null },
  coordinator: { loaded: false, data: null },
  member: { memberId: null, loading: false, data: null }
};